// extracted by mini-css-extract-plugin
module.exports = {"list":"CreditCardIconsList_list__3Yd6b"};